<script>
  import FieldSettings from "../components/fieldSettings.svelte";
  import PageContainer from "../components/shared/PageContainer.svelte";
</script>

<PageContainer>
  <div class="grid gap-3 w-full">
    <div class="uimodule">
      <FieldSettings />
    </div>
  </div>
</PageContainer>
